<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.waba"
        ref="RkmDataTable"
    >
        <template v-slot:cell(waba_numero_display_phone_number)="row">
            {{row.value | whatsapp}}
        </template>

        <template v-slot:cell(actions)="{item}">
            <rkm-button
                v-if="authorize('cadastro-waba-update')"
                :disabled="!item.waba_numero_phone_number_id"
                :color="item.waba_numero_phone_number_id ? 'success' : 'secondary'"
                @click="handleValidate(item)"
                small
                title="Solicitar validação"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="check-circle" />
            </rkm-button>

            <rkm-button
                v-if="authorize('cadastro-waba-update')"
                :to="{name: 'cadastro-waba-edit', params: {id: item.waba_numero_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="authorize('cadastro-waba-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

// Plugins.
import getWebSocket from '@/plugins/websocket'

// Utils.
import format from '@/utils/format'

export default {
    computed: {
        fields() {
            return [
                {key: 'waba_numero_display_phone_number', label: 'Número', name: 'cadastro_waba_numeros.display_phone_number', searchable: true, sortable: true},
                {key: 'waba_numero_verified_name', label: 'Nome verificado', name: 'cadastro_waba_numeros.verified_name', searchable: true, sortable: true},
                {key: 'waba_numero_phone_number_id', label: 'ID WABA', name: 'cadastro_waba_numeros.phone_number_id', searchable: true, sortable: true},
                {class: 'text-center', key: 'waba_numero_quality_rating', label: 'Qualidade', name: 'cadastro_waba_numeros.quality_rating', searchable: true, sortable: true},
                {key: 'waba_numero_classification', label: 'Classificação', name: 'cadastro_waba_numeros.classification', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    data: () => ({
        validationChannel: null,
    }),
    filters: {
        whatsapp: format.whatsapp,
    },
    mounted() {
        const webSocket = getWebSocket()

        if (webSocket === null) {
            return
        }

        this.validationChannel = webSocket.subscribe('private-cadastro.waba')
        this.validationChannel.bind('waba.number.validated', this.handleNumberValidated)
    },
    beforeDestroy() {
        const webSocket = getWebSocket()

        if (webSocket !== null && this.validationChannel !== null) {
            this.validationChannel.unbind('waba.number.validated', this.handleNumberValidated)
            webSocket.unsubscribe('private-cadastro.waba')
        }
    },
    inject: ['repositories'],
    methods: {
        handleNumberValidated(validation) {
            this.$refs.RkmDataTable.refresh()
            this.showSuccessNotification(
                'Validação concluída',
                `A saúde do número WABA ${validation.phone_number_id} foi atualizada.`
            )
        },
        handleValidate(item) {
            const validate = () => this.repositories.cadastro.waba.validate(item.waba_numero_id)
                .then(() => this.showSuccessNotification(
                    'Solicitação enviada',
                    `A validação do número ${item.waba_numero_display_phone_number} foi solicitada ao Engine.`
                ))

            this.showPrimaryConfirmation(
                'Confirmação',
                `Deseja solicitar a validação do número ${item.waba_numero_display_phone_number}?`,
                validate,
                this.handleError
            )
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.waba.destroy(item.waba_numero_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir o número ${item.waba_numero_display_phone_number}?`, destroy, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>
